import {
    http
} from "@/assets/utils/api";

/**
 * 获取题型字典（根据课程Id）
 */
export const getQuestionTypeList = (courseId) => http.get('/questionYymCourseQuestion/getQuestionTypes/' + courseId);

/**
 *  视频弹题 
 */
export const videoQuestion = (courseId, schemeId, roundId, phaseId, chapterId) => http.get(`/yymCourseQuestionExamPaper/getVideoQuestion/${courseId}/${schemeId}/${roundId}/${phaseId}/${chapterId}`);

/**
 * 视频弹题提交
 * @param {*} data 
 * @returns 
 */
export const submitVideoQuestion = (data) => http.post('/examPaperRecord/savePaperRecord', data);

/**
 * 获取课程下测试列表
 * @param {*} courseId 
 * @returns 
 */
export const getCourseTestList = (courseId) => http.get('/questionYymCourseQuestion/getByCourseId/' + courseId);

/**
 * 
 * @param {*} chapterType 章节类型（1=目录 对应章节测试，2=章节 对应测验测试 3=随堂练习测试） 
 * @param {*} examId  1.章节测试id 2.测验测试id 3.章节id
 * @returns 
 */
export const getExamByExamId = (chapterType, examId) => http.get(`/questionYymCourseQuestion/${chapterType}/${examId}`);

/**
 * 章节测试保存/提交
 */
export const saveExam = (data) => http.post('/examPaperRecord/savePaperRecord', data,{custom: {isTimeout: true}});

/**
 * 获取随堂练习列表
 */
export const getClassroomPractice = (courseId) => http.get('/yymCoursePracticeQuestion//getByChapterId/' + courseId);

/***
 * 获取随堂练习试题  chapterType固定值3
 */
export const getPracticeList = (examId) => http.get(`/questionYymCourseQuestion/${3}/${examId}`);

/**
 * 随堂练习保险/提交
 */
export const savePractice = (data) => http.post('/examPaperRecord/savePaperRecord', data);

/**
 * 查询课程最新学习章节（用于闯关学习判定章节是否可观看）
 */
export const getLastChapterBySubmitCount = (data) => http.post('/yymCourseChapter/getSubmitCount', data);

/**
 * 结业考试
 */
export const getChapterExamList = (courseId) => http.get('/questionYymCourseQuestion/getExamByCourseId/' + courseId);

/**
 * 
 * @param {*} chapterType 章节类型（1=目录 对应章节测试，2=章节 对应测验测试 3=随堂练习测试） 
 * @param {*} examId  1.章节测试id 2.测验测试id 3.章节id
 * @returns 
 */
export const getChapterExamByExamId = (chapterType, examId) => http.get(`/questionYymCourseQuestion/${chapterType}/${examId}`);

/**
 * 我的考试列表
 */
export const getMyExamList = (data) => http.post('/questionYymCourseQuestion/myExam', data);

/**
 * 测验列表（新）
 */
export const getTestExamList = (courseId, schemeId, roundId) => http.get(`/yymCourseQuestionExamPaper/getByCourseId/${courseId}/${schemeId}/${roundId}`);

/***
 * 获取自定义作业信息
 */
export const getCustomizeHomeworkInfo = (examId) => http.get(`/yymCourseQuestionExamPaper/getExamCustom/${examId}`);

/**
 * 自定义作业提交
 */
export const submitCustomizeHomework = (data) => http.post('/examPaperRecord/saveExamCustom',data);

/**
 * 闯关结果
 */
export const getChallengeResult = (courseId,schemeId,roundId,phaseId,chapterId) => http.get(`/examPaperRecord/getLevelRecordCount/${courseId}/${schemeId}/${roundId}/${phaseId}/${chapterId}`);

/**
 * 获取闯关试卷（新接口）
 */
export const getChallengeInfo = (paperId,sort) => http.get(`/yymCourseQuestionExamPaper/getLevelPaper/${paperId}/${sort}`);

/***
 * 经典错题（五步-纠错-经典错题）
 */
export const getClassicsWrongQuestion = (courseId,schemeId,roundId,phaseId,chapterId) => http.get(`/yymCourseQuestionExamPaper/getErrorCorrection/${courseId}/${schemeId}/${roundId}/${phaseId}/${chapterId}`);

/**
 * 获取章节阶段错题集合（五步-纠错-错题巩固）
 */
export const getPhaseWrongQusetion = (params) => http.get('/examPaperRecord/getWrongQuestionsPaper',{params});

/**
 * 获取作答记录
 */
export const getExamRecordList = (examId) => http.get(`/examPaperRecord/getExamRecord/${examId}`);

/**
 * 获取作答记录详情
 */
export const getExamRecordInfo = (recordId) => http.get(`/examPaperRecord/getExamRecordDetail/${recordId}`);

/**
 * 获取已完成的作业列表
 */
export const getMyFinishedHomework = (data) => http.post('/yymCourseQuestionExamPaper/getExamByIsCorrect',data);

/**
 * 作答记录
 */
export const getPaperRecordInfo = (recordId) => http.get(`/examPaperRecord/getExamRecordDetail/${recordId}`);

/**
 * 获取自定义作业作答记录详情
 */
export const getCustomizeHomeworkRecordInfo = (recordId) => http.get(`/examPaperRecord/getExamRecordCustomDetail/${recordId}`);

/**
 * 获取作答试卷（系统自动判分）
 */
export const getUserExamRecord = (recordId) => http.get(`/examPaperRecord/getUserExamRecord/${recordId}`);

/**
 * 纠错-获取用户错题集合（新）
 */
export const getUserPhaseWrongQuestion= (params) => http.get('/yymCoursePhaseWrongPool/getCorrectWrongPaper',{params});

/**
 * 纠错-保存
 */
export const saveUserPhaseWrongQuestion = (data) => http.post('/yymCoursePhaseWrongPool/saveWrongPoolPaperRecord',data,{custom: {isTimeout: true}});

/**
 * 纠错练习/重做答题记录
 */
export const getUserPhaseWrongQuestionRecordInfo = (recordId) => http.get(`/yymCoursePhaseWrongPool/getWrongPoolExamRecord/${recordId}`);

/**
 * 获取课后作业列表
 */
export const getAfterHomeworList = (data) => http.post('/yymCourseHomework/getList',data);

/**
 * 课后作业统计
 */
export const getAfterHomeworkCount = (courseId) => http.get(`/yymCourseHomework/getHomeworkCount/${courseId}`);

/**
 * 课后作业试卷统计
 */
export const getAfterHomeworkPaperCount = (paperId) => http.get(`/yymCourseHomework/getPaperCount/${paperId}`);

/**
 * 获取课后作业试卷
 */
export const getAfterHomeworkPaperInfo = (paperId) => http.get(`/yymCourseHomework/getByPaperId/${paperId}`);

/**
 * 保存答题记录（课后作业）
 */
export const saveAfterHomework = (data) => http.post('/yymCourseHomework/savePaperRecord',data);

/**
 * 获取课后作业答题记录（试卷）
 */
export const getAfterHomeworkRecordInfo = (recordId) => http.get(`/yymCourseHomework/getExamRecordDetail/${recordId}`);

/**
 * 获取课后作业（自定义作业）
 */
export const getAfterHomeworkCustom = (homeworkId) => http.get(`/yymCourseHomework/getExamCustom/${homeworkId}`);

/**
 * 获取课后作业（自定义作业）--作答记录
 */
export const getAfterHomeworkCustomRecord = (recordId) => http.get(`/yymCourseHomework/getExamRecordCustomDetail/${recordId}`);

/**
 * 课后作业（自定义作业提交）
 */
export const submitAfterCustomizeHomework = (data) => http.post('/yymCourseHomework/saveExamCustom',data);

/**
 * 在线学习---考试统计
 */
export const getExamCount = () => http.get('/yymCourseTest/getCount');

/**
 * 在线学习---考试列表
 */
export const getExamList = (status,courseId) => http.get(`/yymCourseTest/getList/${status}/${courseId}`);

/**
 * 在线学习---考试详情
 */
export const getExamInfo = (testId) => http.get(`/yymCourseTest/getById/${testId}`);

/**
 * 在线学习---考试试卷
 */
export const getPaperList = (paperId) => http.get(`/yymCourseTest/getByPaperId/${paperId}`);

/**
 * 在线学习---考试提交
 */
export const submitExamPaper = (data) => http.post('/yymCourseTest/savePaperRecord',data);

/**
 * 在线学习---考试作答详情
 */
export const getNewExamRecordInfo = (recordId) => http.get(`/yymCourseTest/getRecordDetail/${recordId}`); 

/**
 * 在线学习---考试统计
 */
export const getPaperCount = () => http.get(`/yymCourseTest/getCount`);

/**
 * 在线学习---考试记录统计
 */
export const getPaperRecordCount = (paperId) => http.get(`/yymCourseTest/getCountByPaperId/${paperId}`);